import { memo, useDeferredValue, useMemo } from 'react';
import { Scheduler } from './UI/Scheduler';
import { RootState } from 'packages/blu-booking/src/store';
import { useSelector } from 'react-redux';
import { useUserHoursCalendar } from 'packages/blu-booking/src/data_fetching/UserHours/UserHoursCalendar';
import { useUserHoursShift } from 'packages/blu-booking/src/data_fetching/UserHours/UserHoursShift';
import { Stack } from '@mui/material';
import { CalendarLoader } from '../../UI/CalendarLoader/CalendarLoader';

/**
 * Wrapper del calendario personale.
 * Il data fetching è stato spostato nel hook useSchedulerData
 * usato direttamente da Scheduler.
 */
export const PersonalCalendarInner = memo(
  function CalendarPersonal(): JSX.Element {
    const { filtersLoad } = useSelector(
      (state: RootState) => state.bluBookingCalendarFilters
    );
    const { selectedDate, view, selectedUsers } = useSelector(
      (state: RootState) => state.bluBookingPersonalCalendar
    );

    const { data: calendar, isLoading: calendarIsLoading } =
      useUserHoursCalendar({
        selectedDate,
        view,
        userId: selectedUsers[0]?.id,
        options: {
          enabled: filtersLoad ?? false,
          refetchInterval: 300000,
        },
      });
    const calendarPerUser = useDeferredValue(calendar);

    const { data: shift, isLoading: shiftIsLoading } = useUserHoursShift({
      selectedDate,
      view,
      userId: selectedUsers[0]?.id,
      options: {
        enabled: filtersLoad ?? false,
        refetchInterval: 300000,
      },
    });
    const shiftPerUser = useDeferredValue(shift);

    const GetContent = useMemo(() => {
      if (calendarIsLoading || shiftIsLoading)
        return (
          <Stack
            alignItems="center"
            justifyContent="center"
            direction="row"
            flex="1"
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: 'var(--base-foreground-color) ',
            }}
          />
        );
      return (
        <Scheduler
          calendarPerUser={calendarPerUser}
          shiftPerUser={shiftPerUser}
        />
      );
    }, [calendarIsLoading, calendarPerUser, shiftIsLoading, shiftPerUser]);

    return (
      <div key="Personal" style={{ height: '100%' }}>
        {GetContent}
        <CalendarLoader open={calendarIsLoading || shiftIsLoading} />
      </div>
    );
  }
);
